import { render, staticRenderFns } from "./assign-coupon.vue?vue&type=template&id=1829e432&scoped=true&"
import script from "./assign-coupon.vue?vue&type=script&lang=js&"
export * from "./assign-coupon.vue?vue&type=script&lang=js&"
import style0 from "./assign-coupon.vue?vue&type=style&index=0&id=1829e432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1829e432",
  null
  
)

export default component.exports